import * as _ from 'underscore';
import { ITypeaheadSource } from '../directives/tbTypeahead';
import { ListResult } from '../fetchers/ListResult';
import { ISliceable } from '../models/ISliceable';
import { Module } from '../Module';

export class SliceableFactory  {

  public static $inject = ['$q'];

  constructor(private $q: ng.IQService) {}

  public fromArray<T>(list: T[] = []): ISliceable<T> {
    return {
      getSlice: (start: number, size: number): ng.IPromise<ListResult<T>> => {
        const slice = list.slice(start, start + size);
        return this.$q.when(new ListResult(slice, start, list.length));
      }
    };
  }

  public searchArray<T>(searchFilterFn: (item: T, search: string) => boolean, listPromise: ng.IPromise<T[]>): ITypeaheadSource {
    let list: T[];

    return (search: string) => {
      let filteredSliceable: ISliceable<T>;

      const createFilteredSliceable = () => {
        let filteredList = _.filter(list, (item: T) => searchFilterFn(item, search));

        // Angular tries to optimize ng-repeats by adding a "$$hashKey property to objects to prevent re-rendering
        // items in a list that have not changed.  This breaks the tbTypeaheadFormat directive that relies on re-rendering
        // each item in the list so we need to pass in "fresh" models every time the search changes.
        filteredList = _.map(filteredList, _.clone);

        filteredSliceable = this.fromArray(filteredList);
      };
      createFilteredSliceable();

      return {
        getSlice: (start: number, size: number): ng.IPromise<ListResult<T>> => {
          if(list) return filteredSliceable.getSlice(start, size);

          return listPromise.then((newList: T[]) => {
            list = newList;
            createFilteredSliceable();
            return filteredSliceable.getSlice(start, size);
          });
        }
      };
    };
  }

}

Module.instance().service('SliceableFactory', SliceableFactory);
